export default __webpack_public_path__ + "static/media/2242.c2f961a3.png";